/**
 * /my-coaching/business/nova/content — My content. It is the one list of the
 * content collections: `?type=` names the one shown, and a collection's own
 * asset route redirects here with it.
 */

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { MyContentPage } from "~/components/nova/content/my-content-page";
import { placementVideosQueryOptions } from "~/lib/queries/learningQuery";
import {
  novaAssetsQueryOptions,
  novaContentQueryOptions,
} from "~/lib/queries/novaAssetsQuery";
import { CONTENT_ASSET_KEYS } from "~/lib/shared/nova/assets/catalog";

export const Route = createFileRoute(
  "/_user/my-coaching/business/nova/content",
)({
  // An unknown type (an old link, a typo) shows every type rather than an
  // error.
  validateSearch: z.object({
    type: z.enum(CONTENT_ASSET_KEYS).optional().catch(undefined),
  }),
  staticData: { title: "My content" },
  loader: async ({ context }) => {
    const userId = context.user.clerkUserId;
    // An optimisation that hands SSR the rows, not the page's data source:
    // the page reads the same queries and shows its own failure and retry.
    await Promise.all([
      context.queryClient
        .ensureQueryData(novaAssetsQueryOptions(userId))
        .catch(() => undefined),
      context.queryClient
        .ensureQueryData(novaContentQueryOptions(userId))
        .catch(() => undefined),
      context.queryClient
        .ensureQueryData(placementVideosQueryOptions())
        .catch(() => undefined),
    ]);
    return { userId };
  },
  component: MyContentRoute,
});

function MyContentRoute() {
  const { userId } = Route.useLoaderData();
  const { type } = Route.useSearch();
  return <MyContentPage type={type ?? null} userId={userId} />;
}
